import CrudCustom from '../../../libs/custom/CrudCustom';

let PendapatanService = new CrudCustom('/penambah-ph-brutos');
export default PendapatanService;
